export default "__VITE_ASSET__DcNhKD3d__"